import React from 'react';
import {Goals, Flex, Textarea, Edit, Submit, Button, Breadcrumbs, Link, Form, Popup} from 'components';
import {over, flow, modal, noop, partialRight, pick} from 'helpers';
import {goals} from 'store';

export function Menu({ project }) {
  return (
    <Popup.Menu>
      <Popup.Menu.Item icon="pencil" onClick={modal(EditModal, { project })}>Edit</Popup.Menu.Item>
      <Popup.Menu.DeleteItem onConfirm={() => goals.dispatch.removeProject(project)}>Delete</Popup.Menu.DeleteItem>
    </Popup.Menu>
  );
}

export function EditModal({ popup, project = {}, onSave = noop, modal }) {
  if (!modal) {
    popup.setClassName('tinted medium');
  }
  return (
    <Form onSubmit={over(popup.close, flow(goals.dispatch.upsertProject, onSave))} initialValues={project}>
      {modal &&
        <h5>{ project.name || 'New' } Project</h5>
      }
      <p><Edit autoFocus name="name" placeholder="Enter name.." required /></p>
      <p><Textarea name="note" placeholder="Enter note.." /></p>
      <Flex className={['right', 'spacing']}>
        {modal &&
          <Button className="borderless" onClick={modal.close}>Cancel</Button>
        }
        <Submit>{['Save']}</Submit>
      </Flex>
    </Form>
  );
}

export function RemoveMenu({ project, popup }) {
  return (
    <Popup.Menu>
      <h6 className="nowrap">Delete this project?</h6>
      <Popup.Menu.Item className="danger" onClick={() => goals.dispatch.removeProject(project)} icon="check">
        Delete
      </Popup.Menu.Item>
      <Popup.Menu.Item onClick={popup.close} icon="close">
        Cancel
      </Popup.Menu.Item>
    </Popup.Menu>
  );
}
